var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var NewSection = styled.div.withConfig({
  displayName: "InsideNavigationContainer__NewSection",
  componentId: "sc-103j4xi-0"
})(["padding:0;", ";", ";"], minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 18px 24px;\n  "]))), minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 18px 30px;\n  "]))));
export var NewSectionInner = styled.div.withConfig({
  displayName: "InsideNavigationContainer__NewSectionInner",
  componentId: "sc-103j4xi-1"
})(["width:100%;max-width:", ";max-width:", ";padding:30px;margin:0 auto;", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.maxWidth;
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? '100%;' : "".concat(grid(10) + 60, "px");
}, function (_ref3) {
  var theme = _ref3.theme,
    grey = _ref3.grey;
  return grey ? "\n      border-radius: ".concat(theme.borderRadius, ";\n      background-color: ").concat(theme.colors.uiLL, ";\n    ") : null;
}, function (_ref4) {
  var textAlign = _ref4.textAlign;
  return textAlign && "text-align: ".concat(textAlign, ";");
}, maxMediaQueries.miniDesktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: 24px;\n    padding-right: 24px;\n  "]))), maxMediaQueries.phone(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding-left: 15px;\n    padding-right: 15px;\n  "]))));
var fixedStyles = css(["position:fixed;top:60px;border-bottom:1px solid ", ";transform:translateY(", "px);", ";&:after{position:absolute;top:-105px;left:0;right:0;height:105px;content:'';background-color:#fff;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderColor;
}, function (_ref6) {
  var reveal = _ref6.reveal,
    theme = _ref6.theme;
  return reveal ? theme.navHeight - 60 : -60 + theme.collapsedNavHeight;
}, maxMediaQueries.phone(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    transform: translateY(", "px);\n  "])), function (_ref7) {
  var reveal = _ref7.reveal,
    theme = _ref7.theme;
  return reveal ? theme.mobileNavHeight - 60 : -60 + theme.collapsedNavHeight;
}));
var stickyStyles = css(["position:sticky;top:", "px;box-shadow:0 1px 3px 0 rgb(46 46 51 / 0.25);"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.collapsedNavHeight;
});
export var InsideNavigationContainer = styled.div.withConfig({
  displayName: "InsideNavigationContainer",
  componentId: "sc-103j4xi-2"
})(["", " ", " z-index:30;left:0;right:0;background-color:#fff;backface-visibility:hidden;transition:transform 0.25s cubic-bezier(0.49,0.42,0.52,0.98);"], function (_ref9) {
  var position = _ref9.position;
  return position.includes(['fixed']) && fixedStyles;
}, function (_ref10) {
  var position = _ref10.position;
  return position.includes(['sticky']) && stickyStyles;
});
export var InsideNavigationInner = styled(NewSectionInner).withConfig({
  displayName: "InsideNavigationContainer__InsideNavigationInner",
  componentId: "sc-103j4xi-3"
})(["display:flex;align-items:center;justify-content:space-between;padding-top:0;padding-bottom:0;font-weight:500;", " nav{display:flex;align-items:center;}"], fontSmoothing);